import { Component, OnInit } from '@angular/core';
import { originalOrder } from 'ngx-unificator/helpers';
import { ModalContent, ModalRef } from '../../../modal-ref';
import { ITournament } from '../../../../../page/tournaments/tournaments.interface';
import { TranslatePipe } from '../../../../services/translation/translate.pipe';
import { TextGradientComponent } from '../../../../shared/components/text-gradient/text-gradient.component';
import { NgTemplateOutlet, SlicePipe, KeyValuePipe } from '@angular/common';

@Component({
    selector: 'app-tournament-prize-modal',
    templateUrl: './tournament-prize-modal.component.html',
    styleUrls: ['./tournament-prize-modal.component.scss'],
    imports: [NgTemplateOutlet, TextGradientComponent, SlicePipe, KeyValuePipe, TranslatePipe]
})
export class TournamentPrizeModalComponent implements OnInit, ModalContent {

  public prizesData$: any = null;

  public originalOrder = originalOrder;

  public modal: ModalRef;

  constructor() {
  }

  get tournament(): ITournament {
    return this.modal.options.data;
  }

  ngOnInit(): void {
    // this.prizesData$ = this.tournament.prizesData$.pipe(
    //   map(e => {
    //     e.mappedPrizes = e.mappedPrizes.slice(0, 50);
    //     return e;
    //   })
    // );
  }

}
